/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CategoryCreateSubCategoryRequest } from '../models/CategoryCreateSubCategoryRequest';
import type { CategoryCreateSubCategoryResponseApiRespoonse } from '../models/CategoryCreateSubCategoryResponseApiRespoonse';
import type { CategoryDeleteSubCategoryRequest } from '../models/CategoryDeleteSubCategoryRequest';
import type { CategoryDeleteSubCategoryResponseApiRespoonse } from '../models/CategoryDeleteSubCategoryResponseApiRespoonse';
import type { CategoryListCategoryRequest } from '../models/CategoryListCategoryRequest';
import type { CategoryListCategoryResponseApiRespoonse } from '../models/CategoryListCategoryResponseApiRespoonse';
import type { CategoryListSubCategoryRequest } from '../models/CategoryListSubCategoryRequest';
import type { CategoryListSubCategoryResponseApiRespoonse } from '../models/CategoryListSubCategoryResponseApiRespoonse';
import type { CategoryShowCategoryRequest } from '../models/CategoryShowCategoryRequest';
import type { CategoryShowCategoryResponseApiRespoonse } from '../models/CategoryShowCategoryResponseApiRespoonse';
import type { CategoryShowSubCategoryRequest } from '../models/CategoryShowSubCategoryRequest';
import type { CategoryShowSubCategoryResponseApiRespoonse } from '../models/CategoryShowSubCategoryResponseApiRespoonse';
import type { CategorySyncCategoryRequest } from '../models/CategorySyncCategoryRequest';
import type { CategorySyncCategoryResponseApiRespoonse } from '../models/CategorySyncCategoryResponseApiRespoonse';
import type { CategoryUpdateSubCategoryRequest } from '../models/CategoryUpdateSubCategoryRequest';
import type { CategoryUpdateSubCategoryResponseApiRespoonse } from '../models/CategoryUpdateSubCategoryResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CategoryManagerService {

    /**
     * List Category
     * @param requestBody
     * @returns CategoryListCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCategory(
        requestBody: CategoryListCategoryRequest,
    ): CancelablePromise<CategoryListCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/category',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show account
     * @param requestBody
     * @returns CategoryShowCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCategoryShow(
        requestBody: CategoryShowCategoryRequest,
    ): CancelablePromise<CategoryShowCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/category/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Sync account
     * @param requestBody
     * @returns CategorySyncCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminCategorySync(
        requestBody: CategorySyncCategoryRequest,
    ): CancelablePromise<CategorySyncCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/category/sync',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * List Category
     * @param requestBody
     * @returns CategoryListSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSubCategory(
        requestBody: CategoryListSubCategoryRequest,
    ): CancelablePromise<CategoryListSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sub-category',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Show account
     * @param requestBody
     * @returns CategoryShowSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSubCategoryShow(
        requestBody: CategoryShowSubCategoryRequest,
    ): CancelablePromise<CategoryShowSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sub-category/show',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Create account
     * @param requestBody
     * @returns CategoryCreateSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSubCategoryCreate(
        requestBody: CategoryCreateSubCategoryRequest,
    ): CancelablePromise<CategoryCreateSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sub-category/create',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Update account
     * @param requestBody
     * @returns CategoryUpdateSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSubCategoryUpdate(
        requestBody: CategoryUpdateSubCategoryRequest,
    ): CancelablePromise<CategoryUpdateSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/sub-category/update',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * Delete account
     * @param requestBody
     * @returns CategoryDeleteSubCategoryResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminSubCategoryDelete(
        requestBody: CategoryDeleteSubCategoryRequest,
    ): CancelablePromise<CategoryDeleteSubCategoryResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/sub-category/delete',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
